import React from "react";
import { SOP_WIKI } from "../../../utils/Constants";
import { getSopParameters } from "../../../utils/Helper";
import ActionButton from "./ActionButton";

function TaskSOP({ task }) {
  const fallbackSOPWiki = SOP_WIKI[task.name] || null;
  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <ActionButton task={task} />
      </div>
      {fallbackSOPWiki && fallbackSOPWiki(getSopParameters(task))}
    </div>
  );
}

export default TaskSOP;



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/TaskSOP.jsx